/** Small uppercase section label with a count, and an optional live indicator. */
export default function SectionHead({ title, count, live }: { title: string; count: number; live?: boolean }) {
  return (
    <div className="mb-3 mt-7 flex items-center gap-2.5">
      {live && <span className="h-2 w-2 rounded-full bg-success shadow-[0_0_0_3px] shadow-success/20" />}
      <h3 className="text-[10.5px] font-semibold uppercase tracking-wider text-faint">{title}</h3>
      <span className="font-mono text-[11px] text-faint">{count}</span>
    </div>
  );
}
